// extracted by mini-css-extract-plugin
module.exports = {"root":"gsjwBMGW","insight":"lUsmcfo5","icon":"oqr1ulzs"};